import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BRAND_ICONS, type BrandIconName } from './brand-icons';

/**
 * Real brand logo (TikTok, Telegram, Bitcoin...) where Lucide only has look-alikes. Inline SVG filled with
 * currentColor and sized 1em, so it takes the colour and font-size of its container like `lucide-icon.icon-em`.
 */
@Component({
	selector: 'app-brand-icon',
	template: `<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path [attr.d]="path()" /></svg>`,
	styles: `
		:host {
			display: inline-flex;
			width: 1em;
			height: 1em;
			flex-shrink: 0;
			vertical-align: middle;
		}
		svg {
			width: 100%;
			height: 100%;
		}
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandIconComponent {
	readonly name = input.required<BrandIconName>();
	protected readonly path = computed(() => BRAND_ICONS[this.name()]);
}
